// extracted by mini-css-extract-plugin
export default {"banner-wrap":"Banner_banner-wrap__030rf","banner":"Banner_banner__aQV0b","desc":"Banner_desc__fVQmF","middle":"Banner_middle__KILgm","en":"Banner_en__m0-dK"};